// Generated by Go - DO NOT EDIT
// 2026-11-03 13:22:03.907993462 +0000 UTC m=+0.002448389

const routes = {
  "asyncJobStatusURL": "/api/v1/async-job-status/",
  "fileBaseURL": "/datei/",
  "filesBaseURL": "/dateien"
};

export default routes;